/// <amd-module name="Widgets/CumulativeFlowDiagram/UnvisitedBoardMessage" />
import * as React from "react";
import { Size } from "Reporting/Visuals/VisualMessages/VisualMessageBase";
import { format } from "VSS/Core/Util/String";
import { VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { ZeroData, ZeroDataActionType } from "VSSUI/ZeroData";
import * as Resources from "Widgets/CumulativeFlowDiagram/Resources";

export interface UnvisitedBoardMessageProps {
    visualTitle: string;
    boardName: string;
    boardUrl: string;
    size: Size;
}

export class UnvisitedBoardMessage extends VssComponent<UnvisitedBoardMessageProps> {
    public render(): JSX.Element {
        return (
            <ZeroData
                className="unvisited-board-message"
                primaryText={format(Resources.Error_PlaceholderBoardUnsupported_Format, this.props.boardName)}
                actionText={format(Resources.UnvisitedBoardVisualMessage_Action_Format, this.props.boardName)}
                actionType={ZeroDataActionType.link}
                actionHref={this.props.boardUrl}
                imagePath={getAssetLocation(
                    this.context.pageContext,
                    "ms.vss-dashboards-web/cumulative-flow-diagram-widget-content/images/cfd-silhouette.png"
                )}
                imageAltText="" // Setting empty alt-text (different from omitting alt-text) is equivalent to setting role="presentation"
            />
        );
    }
}
